import styled, {keyframes} from "styled-components";
import {useContext} from "react";
import {AudioPlayerContext} from "./AudioPlayerContext";

export function ProgressBar() {
  const { audioRef, isReady, trackProgress } = useContext(AudioPlayerContext);

  const setProgressValue = (event) => {
    const { clientX } = event;
    const { left, width } = event.currentTarget.getBoundingClientRect();
    const offsetX = clientX - left;
    audioRef.current.currentTime = (offsetX / width) * audioRef.current.duration;
  }
  if (!isReady) {
    return (
      <ProgressBarContainer>
        <LoadingBar>
          <span/>
        </LoadingBar>
      </ProgressBarContainer>
    )
  }
  return (
    <ProgressBarContainer onClick={setProgressValue}>
      <Seeker value={trackProgress} max={audioRef.current.duration} />
    </ProgressBarContainer>
  )
}

const rightJoinInMiddle = keyframes`
  0% {
    right: 0;
    width: 0;
    opacity: 1;
  }
  85% {
    right: 100%;
    width: 100%;
    opacity: .5;
  }
  100% {
    right: 200%;
    width: 100%;
    opacity: 0;
  }
`;
const leftJoinInMiddle = keyframes`
  0% {
    left: 0;
    width: 0;
    opacity: 1;
  }
  85% {
    left: 100%;
    width: 100%;
    opacity: .5;
  }
  100% {
    left: 200%;
    width: 100%;
    opacity: 0;
  }
`;
const ProgressBarContainer = styled.div`
  cursor: pointer;
  flex-grow: 1;
`;
const LoadingBar = styled.div`
  display: flex;
  width: 100%;
  height: 0.5rem;
  background-color: white;
  border-radius: 5px;
  position: relative;
  overflow: hidden;
  box-shadow: inset 0 1px 3px 0 rgba(0, 0, 0, 0.50);

  span {
    position: relative;
    width: 100%;
    overflow: hidden;

    &::before, &::after {
      content: '';
      width: 25%;
      height: 0.5rem;
      display: block;
      position: absolute;
      background-color: #FF6600;
      animation-duration: 1.2s;
      animation-timing-function: ease-in;
      animation-iteration-count: infinite;
      animation-direction: normal;
    }

    &::before {
      animation-name: ${leftJoinInMiddle};
      left: 0;
    }

    &::after {
      right: 0;
      animation-name: ${rightJoinInMiddle};
    }
  }
`;
const Seeker = styled.progress`
  display: block;
  width: 100%;
  height: 0.75rem;
  background-color: #BFBBBF;
  border-radius: 4px;

  &::-webkit-progress-bar {
    background-color: #BFBBBF;
    border-radius: 4px;
  }

  &::-webkit-progress-value {
    background-color: #423F67;
    border-radius: 4px;
  }

  &::-moz-progress-bar {
    background-color: #423F67;
    border-radius: 4px;
  }

  &::-ms-fill {
    background-color: #423F67;
    border-radius: 4px;
  }

  @media (min-width: 768px) {
    //display: block;
  }
`;
